import { Chip } from "@mui/material"

import colors from "@/styles/colors"

const chipStyles = {
  backgroundColor: "transparent",
  borderColor: colors.primary["300"],
  color: colors.grey["800"],
  "& .MuiChip-deleteIcon": {
    color: colors.primary["300"],
  },
}

interface FilterChipProps {
  label: string
  onDelete?: () => void
}

// TODO: make shared common component
export const PurchaseOrderFilterChip: React.FC<FilterChipProps> = ({ label, onDelete }) => {
  return <Chip label={label} onDelete={onDelete} variant='outlined' color='primary' sx={chipStyles} />
}
